import React from "react";
import { motion } from "framer-motion";
import "./videoWithText.scss";

const VideoWithText = () => {
  return (
    <div className="founder-video-section">
      <motion.div
        className="founder-video"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <iframe
          src="/anupvideo1.mp4"
          title="Founder Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </motion.div>
      <motion.div
        className="founder-content"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="founder-title">Founder’s Talk</h1>
        <p className="founder-description">
          When I started Arrow Digital, my goal was clear—to help businesses grow online with real, measurable results. Too many businesses struggle with ineffective marketing, and I wanted to change that with data-driven strategies, performance-focused campaigns, and transparent execution.
        </p>
        <p className="founder-name">Anup Batra (Founder at Arrow Digital)</p>
      </motion.div>
    </div>
  );
};

export default VideoWithText;
